function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
/* THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY. */
import React, { forwardRef } from 'react';
import { jsx as ___EmotionJSX } from "@emotion/react";
var SvgFlagCn = /*#__PURE__*/forwardRef(function (props, svgRef) {
  return ___EmotionJSX("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 40 32",
    ref: svgRef
  }, props), ___EmotionJSX("path", {
    fill: "#be1e2d",
    d: "M0 32h40V0H0z"
  }), ___EmotionJSX("path", {
    fill: "#fcd21d",
    d: "M5.958 7.44L7.16 4.8l1.271 2.602 2.769.38-1.972 2.071.51 2.875-2.49-1.324-2.454 1.397.434-2.888L3.2 7.901l2.758-.461zm6.346-3.185l.481-1.055.509 1.04 1.106.152-.788.829.205 1.149-.998-.531-.979.56.171-1.156-.811-.804 1.104-.185zm3.199 3.201l.481-1.056.509 1.041 1.107.149-.789.829.205 1.151-.998-.53-.98.56.171-1.155-.809-.806 1.103-.183zm-3.199 6.4l.481-1.056.509 1.041 1.106.151-.788.827.205 1.151-.998-.53-.979.56.171-1.155-.811-.804 1.104-.185zm3.199-3.201l.481-1.055.509 1.04 1.107.152-.789.829.205 1.149-.998-.531-.98.56.171-1.156-.809-.804 1.103-.185z"
  }), ___EmotionJSX("path", {
    fill: "#2d2926",
    opacity: 0.15,
    d: "M38 30H2V2h36v28zm2-30H0v32h40V0z"
  }));
});
export default SvgFlagCn;